export default __webpack_public_path__ + "static/media/grp2_w640.2d909311.jpeg";